<template>
	<div>
		<div class="row inline q-py-md">
			<div class="col">
				<q-btn v-for="group in groupedSpeciesList"
					   :key="group.letter"
					   :label="group.letter"
					   @click="jumpToGalleryAnchor('#gallery-jump-anchor-' + group.letter)"
					   flat
				/>
			</div>
		</div>

		<q-list dense>
			<div v-for="group in groupedSpeciesList" :key="group.name" :id="'gallery-jump-anchor-' + group.letter">
				<q-item-section
						v-for="category in group.groups"
						:key="category.name"
						top
				>
					<template v-if="category.species.length > 1">
						<!-- render list of species in same category -->
						<q-item-label header>{{ category.name }}</q-item-label>
						<q-item v-for="species in category.species"
								:key="species.uid"
								:inset-level="1"
								@click="newSpeciesLogSearch(species)"
								clickable
								dense
						>
							{{ getDisplayName(species) }}
						</q-item>
					</template>
					<template v-else>
						<!-- do not render inset list if category only has one species -->
						<q-item @click="newSpeciesLogSearch(category.species[0])"
								:inset-level="0"
								class="text-bold"
								clickable
								dense
						>
							{{ getDisplayName(category.species[0]) }}
						</q-item>
					</template>
				</q-item-section>
			</div>
		</q-list>
	</div>
</template>

<script>
	import {mapGetters, mapState} from "vuex";
	import {GALLERY_SORTING} from "@/common/constants";
	import LogSearchMixin from "@/mixins/LogSearchMixin";

	export default {
		name: "GalleryList",
		mixins: [LogSearchMixin],
		computed: {
			...mapState({
				speciesList: state => state.species.speciesList,
				gallerySorting: state => state.species.gallerySorting,
				gallerySortingDirection: state => state.species.gallerySortingDirection
			}),
			...mapGetters(['filteredSpeciesList']),
			groupedSpeciesList() {
				switch (this.gallerySorting) {
					case GALLERY_SORTING.NAME:
						return this.groupSpeciesListByCategory();
					case GALLERY_SORTING.TRADENAME:
						return this.groupSpeciesListByTradename();
					case GALLERY_SORTING.BOTANICALNAME:
						return this.groupSpeciesListByBotanicalname();
				}
			}
		},
		methods: {
			getDisplayName(species) {
				switch (this.gallerySorting) {
					case GALLERY_SORTING.NAME:
						return species.name;
					case GALLERY_SORTING.TRADENAME:
						return species.tradename;
					case GALLERY_SORTING.BOTANICALNAME:
						return species.botanicalname;
				}
			},
			jumpToGalleryAnchor(anchorId) {
				window.scrollTo(0, document.querySelector(anchorId).offsetTop);
			},
			sortSpeciesListByName() {
				const speciesList = this.filteredSpeciesList.sort((a, b) => {
					return (a.category.name + a.name).localeCompare(b.category.name + b.name);
				});

				return this.gallerySortingDirection ? speciesList.reverse() : speciesList;
			},
			sortSpeciesListByTradename() {
				const speciesList = this.filteredSpeciesList.sort((a, b) => {
					return (a.tradename).localeCompare(b.tradename);
				});

				return this.gallerySortingDirection ? speciesList.reverse() : speciesList;
			},
			sortSpeciesListByBotanicalname() {
				const speciesList = this.filteredSpeciesList.sort((a, b) => {
					return (a.botanicalname).localeCompare(b.botanicalname);
				});

				return this.gallerySortingDirection ? speciesList.reverse() : speciesList;
			},
			/**
			 * Groups Species List under first letter of category name
			 * @returns {Array}
			 */
			groupSpeciesListByCategory() {
				let jumpSections = [],
					currentSection = null,
					currentCategory = null;

				this.sortSpeciesListByName().forEach((species, index) => {
					if (currentSection === null || currentSection.letter !== species.category.name.charAt(0).toUpperCase()) {
						currentSection = {letter: species.category.name.charAt(0).toUpperCase(), groups: []};
						jumpSections.push(currentSection);
					}

					if (currentCategory === null || currentCategory.name !== species.category.name) {
						currentCategory = {name: species.category.name, species: []};
						currentSection.groups.push(currentCategory);
					}

					currentCategory.species.push(species);
				});

				return jumpSections;
			},
			/**
			 * Groups Species List under first letter of species trade name
			 * @returns {Array}
			 */
			groupSpeciesListByTradename() {
				let jumpSections = [],
					currentSection = null,
					currentGroup = null;

				this.sortSpeciesListByTradename().forEach((species) => {
					if (currentSection === null || currentSection.letter !== species.tradename.charAt(0).toUpperCase()) {
						currentSection = {letter: species.tradename.charAt(0).toUpperCase(), groups: []};
						jumpSections.push(currentSection);
					}

					if (currentGroup === null || currentGroup.name !== species.tradename.charAt(0).toUpperCase()) {
						currentGroup = {name: species.tradename.charAt(0).toUpperCase(), species: []};
						currentSection.groups.push(currentGroup);
					}

					currentGroup.species.push(species);
				});

				return jumpSections;
			},
			/**
			 * Groups Species List under first letter of species botanical name
			 * @returns {Array}
			 */
			groupSpeciesListByBotanicalname() {
				let jumpSections = [],
					currentSection = null,
					currentGroup = null;

				this.sortSpeciesListByBotanicalname().forEach((species) => {
					if (currentSection === null || currentSection.letter !== species.botanicalname.charAt(0).toUpperCase()) {
						currentSection = {letter: species.botanicalname.charAt(0).toUpperCase(), groups: []};
						jumpSections.push(currentSection);
					}

					if (currentGroup === null || currentGroup.name !== species.botanicalname.charAt(0).toUpperCase()) {
						currentGroup = {name: species.botanicalname.charAt(0).toUpperCase(), species: []};
						currentSection.groups.push(currentGroup);
					}

					currentGroup.species.push(species);
				});

				return jumpSections;
			}
		}
	}
</script>